import { Navigate } from 'react-router';

import { selectIsAuthenticated, selectNeedsOrgSetup } from '@/features/auth/store/authSlice';
import { ROUTES } from '@/routes';
import { useAppSelector } from '@/store/hooks';

/**
 * Handles the root path `/`.
 * Authenticated, no organization yet → /org-setup
 * Authenticated  → /dashboard
 * Unauthenticated → /login
 */
export function RootRedirect() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const needsOrgSetup = useAppSelector(selectNeedsOrgSetup);

  if (!isAuthenticated) return <Navigate to={ROUTES.login} replace />;
  return <Navigate to={needsOrgSetup ? ROUTES.orgSetup : ROUTES.dashboard} replace />;
}
